/*
 * Utils.ts
 *
 * Module for utility functions
 */

// Creates a promise that rejects in <ms> milliseconds and
// returns the race between the created timeout promise and the passed in promise
export function createTimeoutPromise<T>(ms: number, promise: Promise<T>): Promise<T> {
	// Create a promise that rejects in <ms> milliseconds
	const timeout = new Promise((resolve, reject) => {
		const id = setTimeout(() => {
			clearTimeout(id);
			reject("Timed out after " + ms + "ms.");
		}, ms);
	});

	// Returns a race between our timeout and the passed in promise
	return Promise.race([promise, timeout]) as Promise<T>;
}

// gets error message
export function getErrorMessage(value?: Error | string | object): string {
	return (value as Error)?.message?.toString() ?? value?.toString();
}

/**
 * Check if an input value is null or undefined
 * @param value: input value
 */
export function isNOU(value: any): boolean {
	return (value === null || value === undefined);
}

/**
 * Create guid string
 */
export function guid(): string {
	// Stitch in '4' in the third group
	return (randomHex4() + randomHex4() + "-" + randomHex4() + "-4" + randomHex4().substr(0, 3) + "-" + randomHex4() + "-"
		+ randomHex4() + randomHex4() + randomHex4()).toLowerCase();
}

/**
 * Create random Hex4 string
 */
function randomHex4(): string {
	return (Math.floor(((1 + Math.random()) * 0x10000))).toString(16).substring(1);
}

/**
 * Check if an input value is an array
 * @param value: input value
 */
export function isArray(value: any): boolean {
	return (value !== null && value !== undefined && (Array.isArray(value)));
}

/**
 * Check if an input value is an array
 * @param value: input value
 */
export function isFunction(value: any): boolean {
	return (value !== null && value !== undefined && (typeof value === "function"));
}

/**
 * Check if an input value is an object
 * @param value: input value
 */
export function isObject(value: any): boolean {
	return (value !== null && value !== undefined && (typeof value === "object"));
}
